import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("showtime_cart")) || [];
        } catch {
            return [];
        }
    });
    const [cartOpen, setCartOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem("showtime_cart", JSON.stringify(items));
    }, [items]);

    const addToCart = (product) => {
        setItems((prev) => {
            const existing = prev.find((i) => i.id === product.id);
            if (existing) {
                return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + 1 } : i));
            }
            return [...prev, { id: product.id, name: product.name, price: product.price, kind: product.kind, image: product.image, qty: 1 }];
        });
        toast.success("IT'S SHOWTIME.", {
            description: `${product.name} added to your cart.`,
        });
    };

    const removeFromCart = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

    const updateQty = (id, delta) =>
        setItems((prev) =>
            prev
                .map((i) => (i.id === id ? { ...i, qty: Math.max(0, i.qty + delta) } : i))
                .filter((i) => i.qty > 0)
        );

    const clearCart = () => setItems([]);

    const count = items.reduce((sum, i) => sum + i.qty, 0);
    const subtotal = items.reduce((sum, i) => sum + i.qty * Number(i.price || 0), 0);

    return (
        <CartContext.Provider value={{ items, count, subtotal, addToCart, removeFromCart, updateQty, clearCart, cartOpen, setCartOpen }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
